import { Link } from 'react-router-dom';
import { PRODUCT_NAME } from '../../../shared/legal/constants';

/**
 * Footer legal links shared by the marketing home page and policy pages.
 */
export default function LandingLegalFooter() {
    const linkClass = 'hover:text-[#00FFD0] transition';

    return (
        <div className="text-center text-xs text-gray-500 space-y-3">
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2">
                <Link to="/privacy-policy" className={linkClass}>
                    Privacy Policy
                </Link>
                <Link to="/terms-of-service" className={linkClass}>
                    Terms of Service
                </Link>
                <Link to="/refund-policy" className={linkClass}>
                    Refund Policy
                </Link>
            </div>
            <p>© {new Date().getFullYear()} {PRODUCT_NAME}. All rights reserved.</p>
        </div>
    );
}
